import React from "react";
import ss from "./Home.module.css";

export default function Home() {
	return (
		<div className={ss.bg}>
			<div className={ss.bg}>
				<a href="Host">创建场次</a>
				<a href="Prepare">设置昵称</a>
				<a href="Await">等待页面</a>
				<a href="Backstage">后台页面</a>
			</div>
		</div>
	);
}
